import { useState, useRef } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

export default function Dashboard() {
  const { user, logout, API } = useAuth();
  const [cfg, setCfg] = useState({
    hoja_extracto: 'DEBITOS', hoja_auxiliar: 'DEBITOS',
    col_valor_extracto: '6', col_valor_auxiliar: '7',
    col_fecha_extracto: '4', col_concepto_extracto: '7',
    col_fecha_auxiliar: '1', col_debito_auxiliar: '7', col_credito_auxiliar: '8',
    tolerancia_dias: '0', nombre: 'Conciliación',
    empresa: 'COMBURED SAS', nit: '900.675.169-7',
    banco: 'BANCOLOMBIA', tipo_cuenta: 'CORRIENTE',
    numero_cuenta: '', codigo: '', mes: '',
    responsable: 'VALENTINA JARAMILLO GAVIRIA', cargo: 'AUXILIAR CONTABLE',
    saldo_extracto: '', saldo_libros: ''
  });
  const [files, setFiles] = useState({ extracto: null, auxiliar: null });
  const [resultado, setResultado] = useState(null);
  const [tab, setTab] = useState('banco');
  const [loading, setLoading] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [generando, setGenerando] = useState(false);
  const [error, setError] = useState('');
  const [showPartidas, setShowPartidas] = useState(false);
  const [partidas, setPartidas] = useState([]);
  const [nuevaPartida, setNuevaPartida] = useState({ tipo: 'consig_no_libros', fecha: '', documento: '', descripcion: '', valor: '' });

  const handle = e => setCfg({ ...cfg, [e.target.name]: e.target.value });
  const setFile = (key, file) => setFiles({ ...files, [key]: file });

  const tiposPartida = {
    'consig_no_libros': 'Consig./Notas crédito no en libros',
    'nd_no_libros': 'Notas débito/Cheques no en libros',
    'consig_no_extracto': 'Consig. no en extracto',
    'cheques_pendientes': 'Cheques pendientes de cobro'
  };

  const conciliar = async () => {
    if (!files.extracto || !files.auxiliar) { setError('Sube los dos archivos'); return; }
    setError(''); setLoading(true); setResultado(null);
    try {
      const fd = new FormData();
      fd.append('extracto', files.extracto);
      fd.append('auxiliar', files.auxiliar);
      Object.entries(cfg).forEach(([k, v]) => fd.append(k, v));
      const r = await axios.post(`${API}/conciliar`, fd);
      setResultado(r.data);
    } catch (e) {
      setError(e.response?.data?.detail || 'Error al conciliar');
    } finally {
      setLoading(false);
    }
  };

  const exportar = async () => {
    if (!files.extracto || !files.auxiliar) return;
    setExporting(true);
    try {
      const fd = new FormData();
      fd.append('extracto', files.extracto);
      fd.append('auxiliar', files.auxiliar);
      Object.entries(cfg).forEach(([k, v]) => { if (k !== 'nombre') fd.append(k, v); });
      const r = await axios.post(`${API}/exportar`, fd, { responseType: 'blob' });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a'); a.href = url; a.download = 'conciliacion.xlsx'; a.click();
    } catch (e) { setError('Error al exportar'); }
    finally { setExporting(false); }
  };

  const generarReporte = async () => {
    if (!files.extracto || !files.auxiliar) return;
    setGenerando(true);
    try {
      const fd = new FormData();
      fd.append('extracto', files.extracto);
      fd.append('auxiliar', files.auxiliar);
      Object.entries(cfg).forEach(([k, v]) => { if (k !== 'nombre') fd.append(k, v); });
      fd.append('partidas_json', JSON.stringify(partidas));
      const r = await axios.post(`${API}/reporte`, fd, { responseType: 'blob' });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Conciliacion_${cfg.banco}_${cfg.mes}.xlsx`;
      a.click();
    } catch (e) { setError('Error al generar reporte'); }
    finally { setGenerando(false); }
  };

  const agregarPartida = () => {
    if (!nuevaPartida.descripcion || !nuevaPartida.valor) return;
    setPartidas([...partidas, { ...nuevaPartida, valor: parseFloat(nuevaPartida.valor) }]);
    setNuevaPartida({ tipo: 'consig_no_libros', fecha: '', documento: '', descripcion: '', valor: '' });
  };

  const eliminarPartida = (i) => setPartidas(partidas.filter((_, idx) => idx !== i));

  const calcularSumas = () => {
    const se = parseFloat(cfg.saldo_extracto) || 0;
    const sl = parseFloat(cfg.saldo_libros) || 0;
    const consig_nl = partidas.filter(p => p.tipo === 'consig_no_libros').reduce((a, p) => a + p.valor, 0);
    const nd_nl = partidas.filter(p => p.tipo === 'nd_no_libros').reduce((a, p) => a + p.valor, 0);
    const consig_ne = partidas.filter(p => p.tipo === 'consig_no_extracto').reduce((a, p) => a + p.valor, 0);
    const cheques = partidas.filter(p => p.tipo === 'cheques_pendientes').reduce((a, p) => a + p.valor, 0);
    const banco_aj = se + consig_nl - nd_nl - consig_ne + cheques;
    const aux_aj = sl + consig_nl - nd_nl - consig_ne + cheques;
    return { banco_aj, aux_aj, diff: banco_aj - aux_aj };
  };

  const rows = resultado ? (
    tab === 'banco' ? resultado.banco :
    tab === 'auxiliar' ? resultado.auxiliar :
    [...resultado.banco.filter(r => !r._cruza), ...resultado.auxiliar.filter(r => !r._cruza)]
  ) : [];

  const sumas = calcularSumas();
  const fmt = n => Number(n).toLocaleString('es-CO', { minimumFractionDigits: 2 });

  return (
    <div style={s.page}>
      <nav style={s.nav}>
        <span style={s.navBrand}>🏦 ConciliaApp</span>
        <div style={s.navRight}>
          <span style={s.navUser}>👤 {user?.nombre}</span>
          {user?.rol === 'admin' && <a href="/admin" style={s.navLink}>Admin</a>}
          <a href="/historial" style={s.navLink}>📋 Historial</a>
          <button onClick={logout} style={s.navBtn}>Salir</button>
        </div>
      </nav>

      <div style={s.content}>
        <div style={s.grid}>
          {/* Panel izquierdo */}
          <div style={s.panel}>
            <h2 style={s.panelTitle}>Nueva conciliación</h2>

            <div style={s.field}>
              <label style={s.label}>Nombre</label>
              <input style={s.input} name="nombre" value={cfg.nombre} onChange={handle} />
            </div>

            <DropZone label="Extracto bancario" icon="🏦" file={files.extracto} onChange={f => setFile('extracto', f)} />
            <DropZone label="Auxiliar contable" icon="📒" file={files.auxiliar} onChange={f => setFile('auxiliar', f)} />

            {/* Saldos */}
            <div style={s.saldosBox}>
              <div style={s.saldosTitle}>💰 Saldos</div>
              <div style={s.advGrid}>
                <div style={s.field}>
                  <label style={s.label}>Saldo extracto banco</label>
                  <input style={s.input} name="saldo_extracto" value={cfg.saldo_extracto} onChange={handle} placeholder="0" type="number" />
                </div>
                <div style={s.field}>
                  <label style={s.label}>Saldo según libros</label>
                  <input style={s.input} name="saldo_libros" value={cfg.saldo_libros} onChange={handle} placeholder="0" type="number" />
                </div>
              </div>
              {(cfg.saldo_extracto || cfg.saldo_libros) && (
                <div style={s.sumasBox}>
                  <div style={s.sumaRow}><span>Saldo ajustado banco:</span><span style={s.sumaVal}>${fmt(sumas.banco_aj)}</span></div>
                  <div style={s.sumaRow}><span>Saldo ajustado libros:</span><span style={s.sumaVal}>${fmt(sumas.aux_aj)}</span></div>
                  <div style={{...s.sumaRow, fontWeight:700, color: Math.abs(sumas.diff) < 1 ? '#16a34a' : '#dc2626'}}>
                    <span>Diferencia:</span><span>${fmt(sumas.diff)}</span>
                  </div>
                </div>
              )}
            </div>

            {/* Datos del reporte */}
            <details style={s.details}>
              <summary style={s.summary}>📋 Datos del reporte</summary>
              <div style={s.advGrid}>
                {[
                  ['empresa', 'Empresa'], ['nit', 'NIT'], ['banco', 'Banco'],
                  ['tipo_cuenta', 'Tipo cuenta'], ['numero_cuenta', 'Número cuenta'],
                  ['codigo', 'Código'], ['mes', 'Mes'], ['responsable', 'Responsable'], ['cargo', 'Cargo']
                ].map(([k, lbl]) => (
                  <div key={k} style={s.field}>
                    <label style={s.label}>{lbl}</label>
                    <input style={s.input} name={k} value={cfg[k]} onChange={handle} />
                  </div>
                ))}
              </div>
            </details>

            {/* Partidas conciliatorias */}
            <details style={s.details} open={showPartidas}>
              <summary style={s.summary} onClick={() => setShowPartidas(!showPartidas)}>📝 Partidas conciliatorias ({partidas.length})</summary>
              <div style={{ marginTop: 10 }}>
                {partidas.length > 0 && (
                  <div style={s.partidasList}>
                    {partidas.map((p, i) => (
                      <div key={i} style={s.partidaItem}>
                        <div style={s.partidaInfo}>
                          <span style={s.partidaTipo}>{tiposPartida[p.tipo]}</span>
                          <span style={s.partidaDesc}>{p.descripcion}</span>
                          <span style={s.partidaVal}>${fmt(p.valor)}</span>
                        </div>
                        <button onClick={() => eliminarPartida(i)} style={s.btnDel}>✕</button>
                      </div>
                    ))}
                  </div>
                )}
                <div style={s.nuevaPartida}>
                  <select style={s.input} value={nuevaPartida.tipo} onChange={e => setNuevaPartida({ ...nuevaPartida, tipo: e.target.value })}>
                    {Object.entries(tiposPartida).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                  </select>
                  <input style={s.input} placeholder="Fecha (dd/mm/aaaa)" value={nuevaPartida.fecha} onChange={e => setNuevaPartida({ ...nuevaPartida, fecha: e.target.value })} />
                  <input style={s.input} placeholder="Documento" value={nuevaPartida.documento} onChange={e => setNuevaPartida({ ...nuevaPartida, documento: e.target.value })} />
                  <input style={s.input} placeholder="Descripción*" value={nuevaPartida.descripcion} onChange={e => setNuevaPartida({ ...nuevaPartida, descripcion: e.target.value })} />
                  <input style={s.input} placeholder="Valor*" type="number" value={nuevaPartida.valor} onChange={e => setNuevaPartida({ ...nuevaPartida, valor: e.target.value })} />
                  <button style={s.btnAgregar} onClick={agregarPartida}>+ Agregar</button>
                </div>
              </div>
            </details>

            {/* Config avanzada */}
            <details style={s.details}>
              <summary style={s.summary}>⚙️ Configuración avanzada</summary>
              <div style={s.advGrid}>
                {[
                  ['hoja_extracto', 'Hoja extracto'], ['hoja_auxiliar', 'Hoja auxiliar'],
                  ['col_fecha_extracto', 'Col. fecha extracto'], ['col_valor_extracto', 'Col. valor extracto'],
                  ['col_concepto_extracto', 'Col. concepto extracto'],
                  ['col_fecha_auxiliar', 'Col. fecha auxiliar'],
                  ['col_debito_auxiliar', 'Col. débito auxiliar'], ['col_credito_auxiliar', 'Col. crédito auxiliar'],
                  ['tolerancia_dias', 'Tolerancia días'],
                ].map(([k, lbl]) => (
                  <div key={k} style={s.field}>
                    <label style={s.label}>{lbl}</label>
                    <input style={s.input} name={k} value={cfg[k]} onChange={handle} />
                  </div>
                ))}
              </div>
            </details>

            {error && <p style={s.error}>{error}</p>}

            <button style={{ ...s.btn, opacity: loading ? 0.6 : 1 }} onClick={conciliar} disabled={loading}>
              {loading ? '⏳ Procesando...' : '⚡ Conciliar'}
            </button>

            {resultado && (
              <>
                <button style={s.btnOutline} onClick={exportar} disabled={exporting}>
                  {exporting ? 'Exportando...' : '📥 Descargar Excel con colores'}
                </button>
                <button style={{ ...s.btnOutline, borderColor: '#16a34a', color: '#16a34a' }} onClick={generarReporte} disabled={generando}>
                  {generando ? 'Generando...' : '📄 Generar Reporte Formal'}
                </button>
              </>
            )}
          </div>

          {/* Panel derecho */}
          <div style={s.results}>
            {!resultado ? (
              <div style={s.empty}>
                <div style={{ fontSize: 48 }}>📊</div>
                <p>Sube los archivos y presiona Conciliar</p>
              </div>
            ) : (
              <>
                <div style={s.stats}>
                  {[
                    ['Banco', resultado.total_banco, '#3b82f6'],
                    ['Auxiliar', resultado.total_aux, '#8b5cf6'],
                    ['Cruzan ✓', resultado.cruzan, '#16a34a'],
                    ['No cruzan ✗', resultado.no_cruzan_banco + resultado.no_cruzan_aux, '#dc2626'],
                  ].map(([lbl, val, color]) => (
                    <div key={lbl} style={s.stat}>
                      <div style={{ ...s.statVal, color }}>{val}</div>
                      <div style={s.statLbl}>{lbl}</div>
                    </div>
                  ))}
                </div>

                {resultado.porcentaje_conciliacion !== undefined && (
                  <div style={s.pctBar}>
                    <div style={{ ...s.pctFill, width: `${resultado.porcentaje_conciliacion}%` }} />
                    <span style={s.pctText}>{resultado.porcentaje_conciliacion}% conciliado</span>
                  </div>
                )}

                <div style={s.tabs}>
                  {[['banco', 'Banco'], ['auxiliar', 'Auxiliar'], ['diff', 'Solo diferencias']].map(([k, lbl]) => (
                    <button key={k} style={{ ...s.tabBtn, ...(tab === k ? s.tabActive : {}) }} onClick={() => setTab(k)}>
                      {lbl}
                      {k === 'diff' && <span style={s.badge}>{resultado.no_cruzan_banco + resultado.no_cruzan_aux}</span>}
                    </button>
                  ))}
                </div>

                <div style={s.tableWrap}>
                  <table style={s.table}>
                    <thead>
                      <tr>
                        {(tab === 'auxiliar' ? resultado.headers_aux : resultado.headers).filter(h => h && h !== 'nan').map(h => (
                          <th key={h} style={s.th}>{h}</th>
                        ))}
                        <th style={s.th}>Cruza</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((row, i) => (
                        <tr key={i} style={row._cruza ? {} : s.rowNo}>
                          {(tab === 'auxiliar' ? resultado.headers_aux : resultado.headers).filter(h => h && h !== 'nan').map(h => (
                            <td key={h} style={s.td}>{row[h]}</td>
                          ))}
                          <td style={s.td}>
                            <span style={row._cruza ? s.badgeSi : s.badgeNo}>
                              {row._cruza ? 'Sí' : 'No'}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function DropZone({ label, icon, file, onChange }) {
  const ref = useRef();
  const [drag, setDrag] = useState(false);
  return (
    <div style={{ ...dz.zone, ...(file ? dz.ready : {}), ...(drag ? dz.drag : {}) }}
      onClick={() => ref.current.click()}
      onDragOver={e => { e.preventDefault(); setDrag(true); }}
      onDragLeave={() => setDrag(false)}
      onDrop={e => { e.preventDefault(); setDrag(false); onChange(e.dataTransfer.files[0]); }}>
      <input ref={ref} type="file" accept=".xlsx,.xls" style={{ display: 'none' }} onChange={e => onChange(e.target.files[0])} />
      <span style={{ fontSize: 20 }}>{file ? '✅' : icon}</span>
      <span style={dz.lbl}>{file ? file.name : label}</span>
      <span style={dz.sub}>{file ? 'Cargado' : 'Arrastra o haz clic'}</span>
    </div>
  );
}

const dz = {
  zone: { display: 'flex', alignItems: 'center', gap: 10, padding: '12px 14px', border: '1.5px dashed #d1d5db', borderRadius: 10, cursor: 'pointer', marginBottom: 10, background: '#fafafa' },
  ready: { borderColor: '#16a34a', background: '#f0fdf4', borderStyle: 'solid' },
  drag: { borderColor: '#3b82f6', background: '#eff6ff' },
  lbl: { fontSize: 13, fontWeight: 500, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  sub: { fontSize: 11, color: '#888' }
};

const s = {
  page: { minHeight: '100vh', background: '#f8fafc', fontFamily: 'system-ui,sans-serif' },
  nav: { background: '#fff', borderBottom: '1px solid #e5e7eb', padding: '0 24px', height: 56, display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  navBrand: { fontWeight: 700, fontSize: 16 },
  navRight: { display: 'flex', alignItems: 'center', gap: 12 },
  navUser: { fontSize: 13, color: '#555' },
  navLink: { fontSize: 13, color: '#2563eb', textDecoration: 'none' },
  navBtn: { padding: '6px 14px', borderRadius: 8, border: '1px solid #e5e7eb', background: 'transparent', cursor: 'pointer', fontSize: 13 },
  content: { padding: '24px', maxWidth: 1400, margin: '0 auto' },
  grid: { display: 'grid', gridTemplateColumns: '380px 1fr', gap: 20 },
  panel: { background: '#fff', borderRadius: 14, padding: '20px', border: '1px solid #e5e7eb', height: 'fit-content' },
  panelTitle: { fontSize: 16, fontWeight: 600, marginBottom: 16, margin: '0 0 16px' },
  field: { marginBottom: 10 },
  label: { fontSize: 12, color: '#666', display: 'block', marginBottom: 4, fontWeight: 500 },
  input: { width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #e5e7eb', fontSize: 13, boxSizing: 'border-box' },
  details: { marginBottom: 14, border: '1px solid #e5e7eb', borderRadius: 10, padding: '8px 12px' },
  summary: { cursor: 'pointer', fontSize: 13, color: '#555', fontWeight: 500 },
  advGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 10 },
  error: { color: '#dc2626', fontSize: 13, margin: '8px 0' },
  btn: { width: '100%', padding: '12px', borderRadius: 10, background: '#2563eb', color: '#fff', border: 'none', fontWeight: 600, fontSize: 15, cursor: 'pointer', marginTop: 4 },
  btnOutline: { width: '100%', padding: '10px', borderRadius: 10, background: '#fff', color: '#2563eb', border: '1.5px solid #2563eb', fontWeight: 600, fontSize: 14, cursor: 'pointer', marginTop: 8 },
  results: { background: '#fff', borderRadius: 14, padding: '20px', border: '1px solid #e5e7eb', minHeight: 400 },
  empty: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: 300, color: '#888', gap: 12 },
  stats: { display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 10, marginBottom: 16 },
  stat: { background: '#f8fafc', borderRadius: 10, padding: '12px', textAlign: 'center', border: '1px solid #e5e7eb' },
  statVal: { fontSize: 24, fontWeight: 700 },
  statLbl: { fontSize: 12, color: '#666', marginTop: 2 },
  tabs: { display: 'flex', gap: 4, marginBottom: 12, borderBottom: '1px solid #e5e7eb', paddingBottom: 0 },
  tabBtn: { padding: '8px 16px', border: 'none', background: 'none', cursor: 'pointer', fontSize: 13, color: '#666', borderBottom: '2px solid transparent', marginBottom: -1, display: 'flex', alignItems: 'center', gap: 6 },
  tabActive: { color: '#111', borderBottomColor: '#2563eb', fontWeight: 600 },
  badge: { background: '#fee2e2', color: '#dc2626', borderRadius: 20, padding: '1px 7px', fontSize: 11, fontWeight: 600 },
  tableWrap: { overflowX: 'auto', border: '1px solid #e5e7eb', borderRadius: 10 },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 12 },
  th: { background: '#f8fafc', padding: '8px 12px', textAlign: 'left', fontWeight: 500, color: '#555', borderBottom: '1px solid #e5e7eb', whiteSpace: 'nowrap' },
  td: { padding: '6px 12px', borderBottom: '1px solid #f0f0f0', whiteSpace: 'nowrap' },
  rowNo: { background: '#fff5f5' },
  badgeSi: { background: '#dcfce7', color: '#16a34a', padding: '2px 8px', borderRadius: 20, fontSize: 11, fontWeight: 600 },
  badgeNo: { background: '#fee2e2', color: '#dc2626', padding: '2px 8px', borderRadius: 20, fontSize: 11, fontWeight: 600 },
  saldosBox: { background: '#f8fafc', borderRadius: 10, padding: '12px', marginBottom: 14, border: '1px solid #e5e7eb' },
  saldosTitle: { fontSize: 13, fontWeight: 600, marginBottom: 8, color: '#333' },
  sumasBox: { marginTop: 10, padding: '8px', background: '#fff', borderRadius: 8, border: '1px solid #e5e7eb' },
  sumaRow: { display: 'flex', justifyContent: 'space-between', fontSize: 12, padding: '3px 0', color: '#444' },
  sumaVal: { fontWeight: 600 },
  pctBar: { position: 'relative', height: 24, background: '#f0f0f0', borderRadius: 12, marginBottom: 16, overflow: 'hidden' },
  pctFill: { position: 'absolute', left: 0, top: 0, height: '100%', background: '#16a34a', borderRadius: 12, transition: 'width 0.5s' },
  pctText: { position: 'absolute', width: '100%', textAlign: 'center', lineHeight: '24px', fontSize: 12, fontWeight: 600, color: '#fff', mixBlendMode: 'difference' },
  partidasList: { marginBottom: 10 },
  partidaItem: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '6px 8px', background: '#f8fafc', borderRadius: 8, marginBottom: 4, border: '1px solid #e5e7eb' },
  partidaInfo: { display: 'flex', flexDirection: 'column', gap: 2, flex: 1 },
  partidaTipo: { fontSize: 10, color: '#2563eb', fontWeight: 600 },
  partidaDesc: { fontSize: 12, color: '#333' },
  partidaVal: { fontSize: 12, fontWeight: 600, color: '#16a34a' },
  btnDel: { background: 'none', border: 'none', color: '#dc2626', cursor: 'pointer', fontSize: 14, padding: '0 4px' },
  nuevaPartida: { display: 'flex', flexDirection: 'column', gap: 6 },
  btnAgregar: { padding: '8px', borderRadius: 8, background: '#2563eb', color: '#fff', border: 'none', fontWeight: 600, cursor: 'pointer', fontSize: 13 },
};
